var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 16,
    viewBox: "0 0 45 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96018 14.5324L1.43339 11.7544C0.0797323 10.6968 0.166163 8.85515 1.65008 7.87969C13.3888 -1.38131 31.6946 -1.31467 43.3545 7.88424C44.831 8.85412 44.9184 10.6878 43.5732 11.7493L40.0395 14.5329C39.4734 14.9876 38.7172 15.265 37.9117 15.3134C35.6218 15.4509 31.2392 13.2475 30.1171 11.8832C29.2409 10.818 29.5846 9.31923 29.5861 8.11744C24.9661 7.11997 20.0875 7.12378 15.465 8.12845C15.4634 9.33024 15.8033 10.8284 14.9245 11.895C13.7972 13.2632 9.39044 15.4839 7.09614 15.3363C6.28257 15.284 5.52239 14.9979 4.96018 14.5324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a6bf8bad.svg";
export { ForwardRef as ReactComponent };